import React from "react";

export default function MaintenanceIllustration() {
  return (
    <div className="maintenance-illustration-wrapper" aria-hidden="true">
      <svg
        viewBox="0 0 960 475"
        className="maintenance-svg-scene"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Shadow Filters */}
          <filter id="sceneSoftShadow" x="-10%" y="-10%" width="130%" height="130%">
            <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#0f172a" floodOpacity="0.08" />
          </filter>
          <filter id="deskDropShadow" x="-5%" y="-5%" width="115%" height="130%">
            <feDropShadow dx="0" dy="10" stdDeviation="12" floodColor="#1e293b" floodOpacity="0.12" />
          </filter>
          <filter id="stickyShadow" x="-10%" y="-10%" width="130%" height="135%">
            <feDropShadow dx="0" dy="12" stdDeviation="16" floodColor="#92400e" floodOpacity="0.14" />
          </filter>
          <filter id="chalkGlow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="0" stdDeviation="1.5" floodColor="#ffffff" floodOpacity="0.45" />
          </filter>

          {/* Gradients */}
          <linearGradient id="stickyYellowGrad" x1="0" y1="0" x2="0.2" y2="1">
            <stop offset="0%" stopColor="#fffef0" />
            <stop offset="40%" stopColor="#fef9c3" />
            <stop offset="100%" stopColor="#fef08a" />
          </linearGradient>

          {/* Robot Gradients */}
          <linearGradient id="robotWhite" x1="0.2" y1="0" x2="0.8" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="55%" stopColor="#f8fafc" />
            <stop offset="100%" stopColor="#cbd5e1" />
          </linearGradient>
          <linearGradient id="robotVisor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0f172a" />
            <stop offset="100%" stopColor="#1e293b" />
          </linearGradient>
          <linearGradient id="robotGoldBadge" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#fef08a" />
            <stop offset="40%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
          <linearGradient id="wrenchChrome" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#f8fafc" />
            <stop offset="35%" stopColor="#cbd5e1" />
            <stop offset="70%" stopColor="#94a3b8" />
            <stop offset="100%" stopColor="#64748b" />
          </linearGradient>

          {/* Chalkboard Gradients */}
          <linearGradient id="woodEasel" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#f59e0b" />
            <stop offset="35%" stopColor="#d97706" />
            <stop offset="100%" stopColor="#b45309" />
          </linearGradient>
          <linearGradient id="woodEaselLegs" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#d97706" />
            <stop offset="100%" stopColor="#92400e" />
          </linearGradient>
          <linearGradient id="chalkBoardSurface" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#1f2e30" />
            <stop offset="50%" stopColor="#182527" />
            <stop offset="100%" stopColor="#111c1e" />
          </linearGradient>

          {/* Book Gradients */}
          <linearGradient id="bookYellowCover" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="60%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
          <linearGradient id="bookPinkCover" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#f43f5e" />
            <stop offset="60%" stopColor="#da1c5c" />
            <stop offset="100%" stopColor="#be123c" />
          </linearGradient>
          <linearGradient id="bookGreenCover" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#a3e635" />
            <stop offset="60%" stopColor="#8dc63f" />
            <stop offset="100%" stopColor="#65a30d" />
          </linearGradient>
          <linearGradient id="bookPages" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#f8fafc" />
            <stop offset="100%" stopColor="#e2e8f0" />
          </linearGradient>

          {/* Ceramic Mug */}
          <linearGradient id="ceramicMug" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="65%" stopColor="#f1f5f9" />
            <stop offset="100%" stopColor="#e2e8f0" />
          </linearGradient>
        </defs>

        {/* ============================================================== */}
        {/* FLOOR / DESK SURFACE BASE SHADOW */}
        {/* ============================================================== */}
        <ellipse cx="490" cy="454" rx="435" ry="18" fill="#0f172a" opacity="0.08" />

        {/* ============================================================== */}
        {/* 1. CHALKBOARD EASEL LEGS (BEHIND BOARD) */}
        {/* ============================================================== */}
        <g id="easel-legs">
          {/* Left Leg */}
          <polygon points="345,360 360,360 346,450 331,450" fill="url(#woodEaselLegs)" />
          {/* Center/Back Leg */}
          <polygon points="465,225 477,225 490,446 478,446" fill="#78350f" opacity="0.8" />
          {/* Right Leg */}
          <polygon points="575,360 590,360 605,450 590,450" fill="url(#woodEaselLegs)" />
        </g>

        {/* ============================================================== */}
        {/* 2. CHALKBOARD (CENTERPIECE) */}
        {/* ============================================================== */}
        <g id="chalkboard" filter="url(#deskDropShadow)">
          {/* Wooden Outer Frame */}
          <rect x="312" y="206" width="310" height="196" rx="16" fill="url(#woodEasel)" stroke="#78350f" strokeWidth="2" />

          {/* Inner Slate Board */}
          <rect x="326" y="220" width="282" height="168" rx="10" fill="url(#chalkBoardSurface)" />

          {/* Subtle Blackboard Glow / Texture line */}
          <rect x="328" y="222" width="278" height="2" fill="#ffffff" opacity="0.08" />

          {/* Sticky Note Top Right (Yellow with Gear) */}
          <g transform="translate(565, 226) rotate(8)">
            <rect width="36" height="36" rx="4" fill="#fef08a" filter="url(#sceneSoftShadow)" />
            <circle cx="18" cy="18" r="6" stroke="#854d0e" strokeWidth="2.5" fill="none" strokeDasharray="3 1.5" />
            <circle cx="18" cy="18" r="2.5" fill="#854d0e" />
          </g>

          {/* Sticky Note Bottom Left (Pink with Heart) */}
          <g transform="translate(334, 338) rotate(-6)">
            <rect width="34" height="34" rx="4" fill="#fbcfe8" filter="url(#sceneSoftShadow)" />
            <path
              d="M17,14 C15,10 10,11 10,15 C10,19 17,23 17,23 C17,23 24,19 24,15 C24,11 19,10 17,14 Z"
              fill="#e11d48"
            />
          </g>

          {/* Chalk Handwritten Text: "Under Maintenance" */}
          <text
            x="467"
            y="286"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="32"
            fontWeight="700"
            fontFamily="'Montserrat', 'Outfit', sans-serif"
            letterSpacing="0.04em"
            filter="url(#chalkGlow)"
          >
            Under
          </text>
          <text
            x="467"
            y="326"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="30"
            fontWeight="700"
            fontFamily="'Montserrat', 'Outfit', sans-serif"
            letterSpacing="0.04em"
            filter="url(#chalkGlow)"
          >
            Maintenance
          </text>

          {/* Yellow Chalk Underline Stroke */}
          <path
            d="M375,344 Q467,358 558,336"
            stroke="#facc15"
            strokeWidth="4.5"
            strokeLinecap="round"
            fill="none"
            filter="url(#chalkGlow)"
          />

          {/* Wooden Chalk Shelf/Tray */}
          <rect x="302" y="396" width="330" height="12" rx="4" fill="url(#woodEasel)" stroke="#78350f" strokeWidth="1" />

          {/* White Chalk Sticks on Tray */}
          <rect x="425" y="392" width="22" height="5" rx="2.5" fill="#ffffff" opacity="0.95" />
          <rect x="455" y="392" width="26" height="5" rx="2.5" fill="#fef08a" opacity="0.95" />

          {/* Chalk Eraser on Tray */}
          <g transform="translate(540, 386)">
            <rect width="40" height="11" rx="2" fill="#78350f" />
            <rect y="8" width="40" height="4" rx="1" fill="#475569" />
          </g>
        </g>

        {/* ============================================================== */}
        {/* 3. YELLOW POST-IT STICKY NOTE ("What we're doing?") */}
        {/* Positioned on Upper-Right, nestled seamlessly above books */}
        {/* ============================================================== */}
        <g id="yellow-sticky-note" transform="translate(642, 68) rotate(2.2)" filter="url(#stickyShadow)">
          {/* Note Paper Body */}
          <rect
            width="250"
            height="170"
            rx="18"
            fill="url(#stickyYellowGrad)"
            stroke="rgba(250, 204, 21, 0.7)"
            strokeWidth="1.2"
          />

          {/* Top Pushpin */}
          <circle cx="125" cy="13" r="5.5" fill="#f59e0b" filter="url(#sceneSoftShadow)" />
          <circle cx="123" cy="11" r="2" fill="#fef08a" />

          {/* Note Title */}
          <text
            x="24"
            y="44"
            fill="#1e293b"
            fontSize="20"
            fontWeight="800"
            fontFamily="'Montserrat', 'Outfit', sans-serif"
            letterSpacing="-0.01em"
          >
            What we're doing?
          </text>

          {/* Checklist Items */}
          {/* Item 1: Improving performance */}
          <g transform="translate(24, 62)">
            <circle cx="10" cy="10" r="9.5" fill="#22c55e" />
            <path d="M5.5 10 L8.5 13 L14.5 7" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <text x="27" y="14.5" fill="#1e293b" fontSize="13.2" fontWeight="600" fontFamily="'Montserrat', 'Outfit', sans-serif">
              Improving performance
            </text>
          </g>

          {/* Item 2: Adding new features */}
          <g transform="translate(24, 98)">
            <circle cx="10" cy="10" r="9.5" fill="#22c55e" />
            <path d="M5.5 10 L8.5 13 L14.5 7" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <text x="27" y="14.5" fill="#1e293b" fontSize="13.2" fontWeight="600" fontFamily="'Montserrat', 'Outfit', sans-serif">
              Adding new features
            </text>
          </g>

          {/* Item 3: Fixing some issues */}
          <g transform="translate(24, 134)">
            <circle cx="10" cy="10" r="9.5" fill="#22c55e" />
            <path d="M5.5 10 L8.5 13 L14.5 7" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <text x="27" y="14.5" fill="#1e293b" fontSize="13.2" fontWeight="600" fontFamily="'Montserrat', 'Outfit', sans-serif">
              Fixing some issues
            </text>
          </g>
        </g>

        {/* ============================================================== */}
        {/* 4. STACK OF 3 BOOKS (LOWER-RIGHT) */}
        {/* ============================================================== */}
        <g id="books-stack" filter="url(#deskDropShadow)">
          {/* BOTTOM BOOK: GREEN ("Happier Teachers") */}
          <g transform="translate(615, 408)">
            <rect x="15" y="4" width="160" height="26" rx="2" fill="url(#bookPages)" stroke="#cbd5e1" strokeWidth="0.8" />
            <line x1="174" y1="10" x2="174" y2="24" stroke="#94a3b8" strokeWidth="1" />
            <rect x="0" y="0" width="178" height="34" rx="6" fill="url(#bookGreenCover)" />
            <path d="M150,34 L156,44 L162,34 Z" fill="#da1c5c" />
            <text
              x="86"
              y="22"
              textAnchor="middle"
              fill="#ffffff"
              fontSize="12.5"
              fontWeight="700"
              fontFamily="'Montserrat', sans-serif"
              letterSpacing="0.03em"
            >
              Happier Teachers
            </text>
          </g>

          {/* MIDDLE BOOK: MAGENTA/BERRY ("Smarter Grading") */}
          <g transform="translate(622, 376)">
            <rect x="15" y="4" width="154" height="24" rx="2" fill="url(#bookPages)" stroke="#cbd5e1" strokeWidth="0.8" />
            <rect x="0" y="0" width="170" height="32" rx="6" fill="url(#bookPinkCover)" />
            <text
              x="82"
              y="21"
              textAnchor="middle"
              fill="#ffffff"
              fontSize="12.5"
              fontWeight="700"
              fontFamily="'Montserrat', sans-serif"
              letterSpacing="0.03em"
            >
              Smarter Grading
            </text>
          </g>

          {/* TOP BOOK: YELLOW/AMBER ("Better Tools") */}
          <g transform="translate(628, 346)">
            <rect x="15" y="4" width="148" height="23" rx="2" fill="url(#bookPages)" stroke="#cbd5e1" strokeWidth="0.8" />
            <rect x="0" y="0" width="164" height="30" rx="6" fill="url(#bookYellowCover)" />
            <text
              x="80"
              y="20"
              textAnchor="middle"
              fill="#78350f"
              fontSize="12.5"
              fontWeight="800"
              fontFamily="'Montserrat', sans-serif"
              letterSpacing="0.03em"
            >
              Better Tools
            </text>
          </g>
        </g>

        {/* ============================================================== */}
        {/* 5. CERAMIC PENCIL MUG WITH SMILEY FACE & STATIONERY */}
        {/* Sits right on top of books, partially overlapping sticky note */}
        {/* ============================================================== */}
        <g id="pencil-mug" transform="translate(668, 238)" filter="url(#sceneSoftShadow)">
          {/* Green Translucent Ruler */}
          <g transform="translate(42, 0) rotate(16)">
            <rect width="18" height="85" rx="3" fill="#86efac" opacity="0.92" stroke="#22c55e" strokeWidth="1.2" />
            <line x1="2" y1="10" x2="8" y2="10" stroke="#15803d" strokeWidth="1" />
            <line x1="2" y1="18" x2="6" y2="18" stroke="#15803d" strokeWidth="1" />
            <line x1="2" y1="26" x2="8" y2="26" stroke="#15803d" strokeWidth="1" />
            <line x1="2" y1="34" x2="6" y2="34" stroke="#15803d" strokeWidth="1" />
            <line x1="2" y1="42" x2="8" y2="42" stroke="#15803d" strokeWidth="1" />
            <line x1="2" y1="50" x2="6" y2="50" stroke="#15803d" strokeWidth="1" />
          </g>

          {/* Yellow Pencil with Eraser */}
          <g transform="translate(26, 12) rotate(-8)">
            <rect width="10" height="75" rx="1.5" fill="#facc15" stroke="#ca8a04" strokeWidth="0.8" />
            <rect y="0" width="10" height="8" fill="#e2e8f0" />
            <rect y="-8" width="10" height="8" rx="2" fill="#f43f5e" />
          </g>

          {/* Blue Pen */}
          <g transform="translate(14, 20) rotate(-18)">
            <rect width="8" height="68" rx="2" fill="#0284c7" />
            <rect y="-6" width="8" height="8" rx="2" fill="#0369a1" />
          </g>

          {/* Pink Pencil */}
          <g transform="translate(5, 24) rotate(-28)">
            <rect width="9" height="62" rx="1.5" fill="#f472b6" stroke="#db2777" strokeWidth="0.8" />
          </g>

          {/* Mug Body */}
          <rect x="0" y="52" width="68" height="58" rx="14" fill="url(#ceramicMug)" stroke="#cbd5e1" strokeWidth="1" />
          {/* Mug Handle */}
          <path
            d="M66,64 C80,64 80,94 66,94"
            stroke="#e2e8f0"
            strokeWidth="8"
            strokeLinecap="round"
            fill="none"
          />

          {/* Yellow Smiley Face Badge */}
          <circle cx="34" cy="80" r="14" fill="#fef08a" stroke="#facc15" strokeWidth="1" />
          <circle cx="29" cy="77" r="1.8" fill="#1e293b" />
          <circle cx="39" cy="77" r="1.8" fill="#1e293b" />
          <path d="M29,83 Q34,88 39,83" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" fill="none" />
        </g>

        {/* ============================================================== */}
        {/* 6. GREEN CLOCK DOODLE: "We'll be back soon! :)" */}
        {/* Positioned cleanly beside books, below the sticky note */}
        {/* ============================================================== */}
        <g id="clock-doodle" transform="translate(806, 318)">
          {/* Green Outline Round Clock */}
          <circle cx="22" cy="22" r="17" stroke="#16a34a" strokeWidth="2.6" fill="#ffffff" />
          <circle cx="22" cy="22" r="2.2" fill="#16a34a" />
          {/* Clock Hands (10:10) */}
          <line x1="22" y1="22" x2="16" y2="13" stroke="#16a34a" strokeWidth="2.3" strokeLinecap="round" />
          <line x1="22" y1="22" x2="31" y2="17" stroke="#16a34a" strokeWidth="2.3" strokeLinecap="round" />

          {/* Dotted Curved Trajectory Arrow */}
          <path
            d="M38,32 Q54,44 48,64"
            stroke="#16a34a"
            strokeWidth="2.2"
            strokeDasharray="3.5 2.5"
            fill="none"
          />
          <polygon points="43,64 50,68 50,59" fill="#16a34a" />

          {/* Handwritten Style Note */}
          <text
            x="24"
            y="78"
            fill="#15803d"
            fontSize="14"
            fontWeight="700"
            fontFamily="'Montserrat', 'Outfit', sans-serif"
            transform="rotate(2, 24, 78)"
          >
            We'll be
          </text>
          <text
            x="20"
            y="94"
            fill="#15803d"
            fontSize="14"
            fontWeight="700"
            fontFamily="'Montserrat', 'Outfit', sans-serif"
            transform="rotate(2, 20, 94)"
          >
            back soon!
          </text>
          <text
            x="42"
            y="110"
            fill="#15803d"
            fontSize="16"
            fontWeight="800"
            fontFamily="'Montserrat', sans-serif"
            transform="rotate(85, 42, 110)"
          >
            :)
          </text>
        </g>

        {/* ============================================================== */}
        {/* 7. ADORABLE 3D CLAY AI ROBOT (LEFT OF CHALKBOARD) */}
        {/* ============================================================== */}
        <g id="ai-robot" filter="url(#deskDropShadow)">
          {/* Shadow on Floor */}
          <ellipse cx="230" cy="445" rx="55" ry="12" fill="#0f172a" opacity="0.12" />

          {/* Robot Feet */}
          <g id="robot-legs">
            <ellipse cx="205" cy="425" rx="22" ry="14" fill="#0f172a" />
            <ellipse cx="205" cy="423" rx="19" ry="11" fill="url(#robotWhite)" />
            <ellipse cx="255" cy="425" rx="22" ry="14" fill="#0f172a" />
            <ellipse cx="255" cy="423" rx="19" ry="11" fill="url(#robotWhite)" />
          </g>

          {/* Torso */}
          <g id="robot-torso">
            <path
              d="M185,340 C185,310 275,310 275,340 C275,395 265,420 230,420 C195,420 185,395 185,340 Z"
              fill="url(#robotWhite)"
              stroke="#cbd5e1"
              strokeWidth="1.5"
            />
            {/* Shading */}
            <path
              d="M192,345 C192,320 268,320 268,345 C268,390 258,412 230,412 C202,412 192,390 192,345 Z"
              fill="#ffffff"
              opacity="0.6"
            />
            {/* Pelvis Joint */}
            <path d="M198,395 Q230,404 262,395" stroke="#0f172a" strokeWidth="6" strokeLinecap="round" />

            {/* Golden "AI" Chest Badge */}
            <g transform="translate(210, 348)">
              <rect width="40" height="26" rx="7" fill="url(#robotGoldBadge)" filter="url(#sceneSoftShadow)" />
              <text
                x="20"
                y="18"
                textAnchor="middle"
                fill="#1e293b"
                fontSize="13"
                fontWeight="900"
                fontFamily="'Montserrat', 'Outfit', sans-serif"
                letterSpacing="0.04em"
              >
                AI
              </text>
            </g>
          </g>

          {/* Chrome Wrench */}
          <g id="wrench" transform="translate(195, 300) rotate(-42)">
            <rect x="0" y="8" width="165" height="24" rx="6" fill="url(#wrenchChrome)" stroke="#64748b" strokeWidth="1.5" />
            <rect x="18" y="14" width="128" height="12" rx="3" fill="#cbd5e1" opacity="0.6" />

            {/* Left Jaw */}
            <g transform="translate(-8, -4)">
              <path
                d="M18,0 C32,0 44,14 44,24 C44,34 32,48 18,48 C2,48 -4,34 -4,24 C-4,14 2,0 18,0 Z"
                fill="url(#wrenchChrome)"
                stroke="#64748b"
                strokeWidth="1.5"
              />
              <polygon points="12,12 30,24 12,36 -8,24" fill="#faf8f5" stroke="#64748b" strokeWidth="1.2" />
            </g>

            {/* Right Jaw resting on chalkboard */}
            <g transform="translate(150, -4)">
              <path
                d="M18,0 C32,0 44,14 44,24 C44,34 32,48 18,48 C2,48 -4,34 -4,24 C-4,14 2,0 18,0 Z"
                fill="url(#wrenchChrome)"
                stroke="#64748b"
                strokeWidth="1.5"
              />
              <polygon points="18,12 36,24 18,36 0,24" fill="#182527" stroke="#64748b" strokeWidth="1.2" />
            </g>
          </g>

          {/* Robot Arms */}
          <g id="robot-arms">
            <path
              d="M190,335 C175,360 190,400 230,390"
              stroke="url(#robotWhite)"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            <circle cx="230" cy="386" r="14" fill="url(#robotWhite)" stroke="#cbd5e1" strokeWidth="1" />
            <circle cx="225" cy="382" r="7" fill="#ffffff" />

            <path
              d="M260,335 C285,345 285,370 268,382"
              stroke="url(#robotWhite)"
              strokeWidth="18"
              strokeLinecap="round"
              fill="none"
            />
            <circle cx="268" cy="382" r="13" fill="url(#robotWhite)" stroke="#cbd5e1" strokeWidth="1" />
          </g>

          {/* Robot Head */}
          <g id="robot-head">
            <rect x="216" y="295" width="28" height="15" rx="4" fill="#0f172a" />

            {/* Ear Pieces */}
            <rect x="156" y="240" width="16" height="34" rx="8" fill="#1e293b" />
            <ellipse cx="164" cy="257" rx="5" ry="12" fill="#475569" />
            <rect x="288" y="240" width="16" height="34" rx="8" fill="#1e293b" />
            <ellipse cx="296" cy="257" rx="5" ry="12" fill="#475569" />

            {/* White Helmet */}
            <rect
              x="165"
              y="200"
              width="130"
              height="105"
              rx="46"
              fill="url(#robotWhite)"
              stroke="#cbd5e1"
              strokeWidth="2"
            />
            <path
              d="M185,210 C210,204 250,204 275,210 C282,212 270,225 230,225 C190,225 178,212 185,210 Z"
              fill="#ffffff"
              opacity="0.8"
            />

            {/* Visor */}
            <rect x="180" y="222" width="100" height="66" rx="26" fill="url(#robotVisor)" />

            {/* Smiling Eyes (^ ^) */}
            <g id="robot-eyes">
              <path
                d="M198,258 Q208,242 218,258"
                stroke="#facc15"
                strokeWidth="5"
                strokeLinecap="round"
                fill="none"
              />
              <path
                d="M242,258 Q252,242 262,258"
                stroke="#facc15"
                strokeWidth="5"
                strokeLinecap="round"
                fill="none"
              />
            </g>
          </g>

          {/* Mortarboard Graduation Cap */}
          <g id="graduation-cap" transform="translate(162, 142)">
            <ellipse cx="70" cy="54" rx="36" ry="14" fill="#0f172a" />
            <polygon points="70,16 138,40 70,64 2,40" fill="#1e293b" stroke="#0f172a" strokeWidth="1.5" />
            <polygon points="70,18 134,40 70,61 6,40" fill="#0f172a" opacity="0.9" />
            <circle cx="70" cy="40" r="4.5" fill="#f59e0b" stroke="#b45309" strokeWidth="1" />
            {/* Tassel */}
            <path
              d="M70,40 Q40,46 22,66"
              stroke="#f59e0b"
              strokeWidth="3"
              strokeLinecap="round"
              fill="none"
            />
            <g transform="translate(15, 64)">
              <rect width="10" height="18" rx="3" fill="#f59e0b" />
              <line x1="3" y1="18" x2="3" y2="24" stroke="#d97706" strokeWidth="1.5" />
              <line x1="5" y1="18" x2="5" y2="25" stroke="#d97706" strokeWidth="1.5" />
              <line x1="7" y1="18" x2="7" y2="24" stroke="#d97706" strokeWidth="1.5" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}
